export enum ServiceActionTypes {
  API_RESPONSE_SUCCESS = '@@service/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR = '@@service/API_RESPONSE_ERROR',

  LIST_SERVICES = '@@service/LIST_SERVICES',
  UPDATE_SERVICE = '@@service/UPDATE_SERVICE',
  GET_SERVICE = '@@service/GET_SERVICE',

  RESET = '@@service/RESET',
}